import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IntroTemplate from '../../components/IntroTemplate/IntroTemplate'; // Adjust the path as per your project structure
import RedirectToPage from '../../components/RedirectToPage/RedirectToPage'; // Adjust the path
import SmallDescription from "../../components/SmallDescription/SmallDescription";
import FootprintStats from "../../components/FootprintStats/FootprintStats";
import ProjectImageScroll from '../../components/ProjectImageScroll/ProjectImageScroll';
import ViewSlider from '../../components/ViewSlider/ViewSlider';

const ServicePage = () => {
  const { id } = useParams(); // Get the service ID from the URL
  const data = getStoredData()?.["5"] ?? {};
  const [services, setServices] = useState(null); // State to store service details
  const [products, setProducts] = useState([]); // State to store products
  const [error, setError] = useState(null); // State for handling errors

  useEffect(() => {
    // Fetch service details by ID
    const fetchService = async () => {
      try {
        const response = await axios.get(`https://shahbad-enterprises-backend.vercel.app/services/${id}`);
        setServices(response.data);
      } catch (err) {
        console.error('Error fetching service details:', err);
        setError('Failed to fetch service details.');
      }
    };

    if (id) {
      fetchService();
    }
  }, [id]);

  useEffect(() => {
    // Fetch products
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/products');
        setProducts(response.data);
      } catch (err) {
        console.error('Error fetching products:', err);
      }
    };

    fetchProducts();
  }, []);

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  if (!services) {
    return <div>Loading service details...</div>; // Show loading message while fetching data
  }

  return (
    <div>
      <IntroTemplate 
        logo={services.icon} 
        title={services.title} 
        image={services.photo?.[0]?.url} 
      />
      <SmallDescription 
        title={services.name} 
        details={services.details} 
      />
      <ProjectImageScroll 
        data={services.photo} 
        title={data.imageHeading} 
        detail={data.imageDetails} 
      />
       <FootprintStats stats={services.stats} />
      <ViewSlider
        title={data.ViewTitle}
        link={data.ViewLink}
        text={data.ViewText}
        items={products}
      />
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText} 
      />
    </div>
  );
};

export default ServicePage;
